import { ACTION_GET_CLIENT_PENDING, ACTION_GET_CLIENT_SUCCESS, ACTION_GET_CLIENT_ERROR } from 'actions/client/action.client-get';

const initialState = {
    clientPending: false,
    client: null,
    clientError: null
}

export default function clientReducer(state = initialState, action) {
    switch (action.type) {
        case ACTION_GET_CLIENT_PENDING:
            return {
                ...state,
                clientPending: true,
                client: {}
            }
        case ACTION_GET_CLIENT_SUCCESS:
            return {
                ...state,
                clientPending: false,
                client: action.client
            }
        case ACTION_GET_CLIENT_ERROR:
            return {
                ...state,
                clientPending: false,
                client: {},
                clientError: action.clientError
            }
        default:
            return state;
    }
}

export const getClientPending = state => state.clientReducer.clientPending;
export const getClient = state => state.clientReducer.client;
export const getClientError = state => state.clientReducer.clientError;
